import React, { useEffect, useState } from "react";
import AppContainer from "../Structure/AppContainer";
import ajaxDepartments from "../../util/remote/ajaxDepartments";
import toast, { Toaster } from "react-hot-toast";
const DepartmentsPage = () => {
  const [departments, setDepartments] = useState([]);
  // fetching departments_list
  const fetch_departmentList = async () => {
    var data = {};
    const server_response = await ajaxDepartments.fetchDepartmentsList(data);
    if (server_response.status === "OK") {
      setDepartments(server_response.details);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetch_departmentList();
  }, []);
  // -----------------------creating department------------------------------
  const [dept, setDept] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { department: dept };
    const server_response = await ajaxDepartments.createDepartment(data);
    if (server_response.status === "OK") {
      fetch_departmentList();
      setDept("");
      toast.success(server_response.message);
    } else {
      toast.error(server_response.message);
    }
  };
  return (
    <AppContainer title="Departments">
      <div>
        <Toaster />
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-1">Create Department</h6>
                  <p className="text-muted card-sub-title">.</p>
                </div>
                <form action="" onSubmit={(e) => handleSubmit(e)}>
                  <div className="d-flex flex-column">
                    <div className="form-group">
                      <input
                        className="form-control"
                        placeholder="Department Name"
                        type="text"
                        value={dept}
                        onChange={(e) => setDept(e.target.value)}
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn ripple btn-main-primary"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <div className="card custom-card card-dashboard-calendar pb-0">
              <label className="main-content-label mb-2 pt-1">
                organisation Department
              </label>
              <span className="d-block tx-12 mb-2 text-muted">
                organisation Departments
              </span>
              <table
                style={{ alignItems: "center" }}
                className="table table-striped table table-hover "
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>NO</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(departments) &&
                    departments.map((dept, key) => (
                      <>
                        <tr>
                          <td className="wd-5p">
                            <div className="main-img-user avatar-md">
                              <img
                                alt="avatar"
                                className="rounded-circle me-3"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/img/animal_house.png"
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-middle ms-3">
                              <div className="d-inline-block">
                                <h6 className="mb-1">{key + 1}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-middle ms-3">
                              <div className="d-inline-block">
                                <h6 className="mb-1">{dept.department}</h6>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default DepartmentsPage;
